import React, { useEffect } from 'react';

import { expVal } from '@confluence/feature-experiments';

import { useSnippetsActions } from './snippetsStore.ts';

/**
 * Provider component that ensures snippets are fetched before the component tree renders.
 */
export const SnippetsProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
	const snippetsActions = useSnippetsActions();

	useEffect(() => {
		if (expVal('cc_snippets', 'isEnabled', false)) {
			// Fire-and-forget: the store handles deduplication and isLoading state
			void snippetsActions.fetchSnippets();
		}
	}, [snippetsActions]);

	// Render children immediately - the fetch happens in the background
	return <>{children}</>;
};
